export default __webpack_public_path__ + "static/media/vadim.e209a21e.webp";